import i18n from "../i18n/i18n";

export const API_URL =
  process.env.REACT_APP_ENV === "development"
    ? process.env.REACT_APP_API_URL_DEV
    : process.env.REACT_APP_API_URL_PROD;

export const PAYPAL_CLIENT_ID =
  process.env.REACT_APP_ENV === "development"
    ? process.env.REACT_APP_PAYPAL_CLIENT_ID_SANDBOX
    : process.env.REACT_APP_PAYPAL_CLIENT_ID_LIVE;

export const API_URL_NODE = process.env.REACT_APP_API_URL_NODE;

export const LANDING_ROUTE = "/";

export const OLD_AFFILIATION_ROUTE = "/i/:id";

export const HOME_ROUTE = "/home";

export const RANKING_ROUTE = "/ranking";

export const LOGIN_ROUTE = "/login";

export const SIGN_UP_ROUTE = "/register";

export const DASHBOARD_ROUTE = "/dashboard";

export const REFERRALS_ROUTE = "/referrals";

export const SETTINGS_ROUTE = "/admin";

export const INFO_ROUTE = "/info";

export const DOWNLOADS_ROUTE = "/downloads";

export const TUTORIALS_ROUTE = "/tutorials";

export const NOTIFICATIONS_ROUTE = "/notifications";

export const FORGOT_ROUTE = "/forgot-password";

export const RESET_ROUTE = "/reset-password";

export const CYCLES_ROUTE = "/cycles";

export const GOLD_ROUTE = "/gold";

export const GOLD_MATRIX_ROUTE = "/gold_matrix";

export const GOLD_MATRIX_ROUTE_ID = "/gold_matrix/:id";

export const GOLD_ROUTE_ID = "/gold/:id";

export const TERMS_AND_CONDITIONS = "/terms-and-conditions";

export const FREQUENTLY_ASKED_QUESTIONS_ROUTE = "/faq";

export const PRIVACY_POLICY = "/privacy-policy";

export const PAYPAL_STATUS_ROUTE = "/paypal";

export const SAFE_ROUTE = "/safe";

export const TICKETS_ROUTE = "/tickets";

export const CRYPTO_ROUTE = "/crypto";

export const REAL_STATE_ROUTE = "/real-state";

export const VERIFY_EMAIL_ROUTE = "/verify-email";

export const REQUEST_CARD_ROUTE = "/request-card";

export const TOKEN_KEY = "@wealthclub-app/token";

export const REFRESH_TOKEN_KEY = "@wealthclub-app/refresh_token";

export const EMAIL_KEY = "@wealthclub-app/email";

export const LANG_KEY = "@wealthclub-app/lang";

export const VIDEO_CHECK_KEY = "@wealthclub-app/video_check";

export const PRIMARY_COLOR = "#F0CB65";

export const YELLOW_LIGHT_COLOR = "#F5E973";

export const BLUE_COLOR = "#02225c";

export const YELLOW_COLOR = "#FAE067";

export const SECONDARY_COLOR = "#F6A566";

export const WHITE_COLOR = "#FDF2D6";

export const RED_COLOR = "#F54509";

export const GREEN_COLOR = "#06A967";

export const PAYPAL_BUTTONS: { [key: string]: string } = {
  "25": "5SK6MTJ7NC6XY",
  "50": "7YHT6M8KN54L6",
  "100": "TDA3QVH69SY4U",
  "250": "3M5J8TUT9FNP4",
  "500": "NDXZCH33CHTQS",
  "1000": "KRJY8YE8Q4PNS",
  "2000": "78WCEBMMPAB5E",
  "3000": "RP9T63DNA82MA",
  "4000": "E73LKECGERS24",
  "5000": "29GRWZ8S4ZH62",
  "10000": "5HUAK6BSJ25N8",
  "20000": "L8EVUP26C7S6U",
  "30000": "ZME24UHKSHQ6U",
  "40000": "2HDYJTAAVVB6A",
  "50000": "AADY2AVGFX6QS",
  "100000": "YKH4U45R5RY2Y",
};

export const BUTTONS_AMOUNT = [
  500, 1000, 2000, 3000, 4000, 5000, 10000, 20000, 30000, 40000, 50000, 100000,
];

export const CRYPTO_AMOUNTS: { [key: string]: number[] } = {
  bitcoin: [
    0.00097, 0.00195, 0.0039, 0.00781, 0.01562, 0.03125, 0.0625, 0.125, 0.25,
    0.5, 1, 2,
  ],
  eth: [
    0.0122, 0.0024, 0.0488, 0.0976, 0.1953, 0.3906, 0.7812, 1.5625, 3.125, 6.25,
    12.5, 25,
  ],
  usdt: [
    500, 1000, 2000, 3000, 4000, 5000, 10000, 20000, 30000, 40000, 50000,
    100000,
  ],
};

export const BUTTONS_AMOUNT_DEPOSIT = [
  25, 50, 100, 250, 500, 1000, 2000, 3000, 4000, 5000, 10000, 20000, 30000,
  40000, 50000, 100000,
];

export const CYCLES_LENGTH = 6;

export const LANGS = ["en", "es", "fr", "sc", "pg", "rs", "cn"];

export const GOLD_BUTTONS = [
  25, 50, 100, 250, 500, 750, 1000, 2500, 5000, 7500, 10000, 25000, 50000,
  75000, 100000,
];

export const GOLD_BUTTONS_BTC = [
  0.0004, 0.0009, 0.0019, 0.0039, 0.0078, 0.0156, 0.0312, 0.0625, 0.125, 0.25,
  0.5, 1, 2, 3, 4,
];

export const GOLD_BUTTONS_USDT = [
  25, 50, 100, 250, 500, 750, 1000, 2500, 5000, 7500, 10000, 25000, 50000,
  75000, 100000,
];

export const GOLD_BUTTONS_ETH = [
  0.003, 0.0061, 0.0122, 0.0244, 0.0488, 0.097, 0.195, 0.39, 0.781, 1.562,
  3.125, 6.25, 12.5, 25, 50,
];

export const GOLD_ARRAY = [
  [0],
  [0, 1],
  [0, 1, 2, 3],
  [0, 1, 2, 3, 4, 5, 6, 7],
  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
];

export const GOLD_NODE_SIZES: { [key: number]: string } = [
  "lg",
  "md",
  "sm",
  "xs",
];

export const MATRIX_NODE_TYPE = [
  "SOCIO PERSONAL",
  "DERRAME INFERIOR",
  "DERRAME SUPERIOR",
  "SALTO DE SOCIO",
  "CUENTA CORPORATIVA",
  "PAGO AL SUPERIOR",
];

export const GOLD_ONE_ARRAY = [
  [0],
  [0, 1],
  [0, 1, 2, 3],
  [0, 1, 2, 3, 4, 5, 6, 7],
];

export const IS_MOBILE = "(max-width: 556px)";

export const IS_TABLET = "(max-width: 768px)";

export const PAYMENT_METHODS = [
  i18n.t("Safe"),
  i18n.t("Cash"),
  i18n.t("PayPal"),
  i18n.t("Cryptocurrencies"),
];

export const MATRIX_NODE_TYPE_COLORS = [
  YELLOW_COLOR,
  SECONDARY_COLOR,
  WHITE_COLOR,
  GREEN_COLOR,
  RED_COLOR,
  BLUE_COLOR,
];

export const TELEGRAM_GROUPS: { [key: string]: string } = {
  es: "https://t.me/joinchat/eNCwpJL9rKwyMDA5",
  en: "https://t.me/joinchat/ciwIjDaArHhiMzM5",
  fr: "https://t.me/joinchat/ciwIjDaArHhiMzM5",
  sc: "https://t.me/joinchat/ciwIjDaArHhiMzM5",
  pg: "https://t.me/joinchat/ciwIjDaArHhiMzM5",
  cn: "https://t.me/joinchat/ciwIjDaArHhiMzM5",
  rs: "https://t.me/joinchat/ciwIjDaArHhiMzM5",
};

export const MAX_DEVELOPMENTS: { [key: string]: object } = {
  "6": {
    max_dev: 15,
    last_push: 60,
  },
  "12": {
    max_dev: 30,
    last_push: 90,
  },
  "18": {
    max_dev: 30,
    last_push: 120,
  },
  "24": {
    max_dev: 60,
    last_push: 180,
  },
};

export const GOLD_SUFFIX: { [key: string]: string } = {
  bitcoin: "BTC",
  usdt: "USDT",
  eth: "ETH",
};
